import type { FaireProductEntity } from "../../entity_types/product";

export const p_8qxjnf6t36: FaireProductEntity = {
  token: "p_8qxjnf6t36",
  type: "product",
  name: "Rust Vintage Western Satin Button Down Maxi Shirt Dress",
  brandToken: "b_cmenfyx54t",
  brandName: "LUCKY & BLESSED",
  imageUrl:
    "https://cdn.faire.com/fastly/3bbae830afc32c3f57ab4fb53d5eedde23aa1a5c64d6f6694ebf8e204c9e2fe2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9aa3f7df65e6cec5db367e3d4f7712989b93eb7eaa728c10ef99f2a0b4d43252.jpeg",
    "https://cdn.faire.com/fastly/e3a6f0fc3f0ec9ede95730bbecffabfafda46db7d4eb7798c94ff7c8804dc5b7.jpeg",
    "https://cdn.faire.com/fastly/588bebd83ba43da000f07bc908a8e729d97b17fd15f906b3e4ca9d36a5c055f8.jpeg",
  ],
  priceDollars: 180,
  description:
    "Capture timeless western style with the Rust Vintage Western Scenic Satin Button Down Maxi Shirt Dress. Featuring an eye-catching vintage-inspired western landscape print on a silky satin fabric, this statement dress blends elegance with cowgirl charm. Designed with a classic collared neckline, full button-down front, long sleeves with button cuffs, and a flowing maxi silhouette, it can be worn belted as a dress or open as a stylish duster. Perfect for rodeos, western events, country concerts, boutique fashion, and everyday western styling.\n\nwestern satin dress\n\nmaxi shirt dress\n\nwestern shirt dress\n\nrust western dress\n\nvintage western print\n\nscenic print dress\n\ncowgirl maxi dress\n\nbutton down dress\n\nwestern boutique clothing\n\ncountry concert outfit\n\nrodeo outfit\n\nlong sleeve western dress\n\nwestern fashion\n\ncowgirl clothing\n\nwestern duster dress\n\nstatement western dress\n\ncollared maxi dress\n\nboutique western dress\n\nwestern boutique apparel\n\nfall western fashion\n\nNFR\nWESTERN\nRODEO\nWESTERN APPAREL",
  tags: [],
  msrpDollars: 360,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:11.481Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
